import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=ef1db7da&scoped=true&"
import script from "./chart2.vue?vue&type=script&lang=js&"
export * from "./chart2.vue?vue&type=script&lang=js&"
import style0 from "./chart2.vue?vue&type=style&index=0&id=ef1db7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1db7da",
  null
  
)

export default component.exports